module.exports = __webpack_public_path__ + "media/images/thumbs-up-5f4cdc43.png";